import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseImage_path } from "../../variables/Variables";
import {
  addInternationalInsurance,
  fetchInternationalInsurance,
  updateInternationalInsurance,
  trashInternationalInsurance,
} from "../../Adapters/ApiAdapter";

const InternationalInsuranceCMS = () => {
  const [data, setData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({ icon: null, existing_icon: "" });
  const [editId, setEditId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await fetchInternationalInsurance();
      setData(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch insurance partners", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  const handleSubmit = async () => {
    const payload = new FormData();
    if (formData.icon) payload.append("icon", formData.icon);

    try {
      let response;
      if (isEditMode) {
        response = await updateInternationalInsurance(editId, payload);
      } else {
        response = await addInternationalInsurance(payload);
      }

      if (response && response.status === "true") {
        toast.success(
          isEditMode
            ? "Insurance partner updated successfully"
            : "Insurance partner added successfully"
        );
        fetchData();
        handleClose();
      } else {
        toast.error("Operation failed");
      }
    } catch (err) {
      console.error("Error submitting data", err);
      toast.error("Something went wrong");
    }
  };

  const handleEdit = (row) => {
    setFormData({ icon: null, existing_icon: row.icon });
    setEditId(row.id);
    setIsEditMode(true);
    setOpenDialog(true);
  };

  const handleTrash = async (id) => {
    try {
      const response = await trashInternationalInsurance(id);
      if (response && response.status === "true") {
        toast.success("Deleted successfully");
        fetchData();
      } else {
        toast.error("Failed to delete");
      }
    } catch (err) {
      console.error("Error deleting item", err);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setFormData({ icon: null, existing_icon: "" });
    setEditId(null);
    setIsEditMode(false);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    {
      field: "icon",
      headerName: "Icon",
      flex: 1,
      renderCell: (params) =>
        params.row.icon ? (
          <img
            src={`${baseImage_path}/${params.row.icon}`}
            alt="icon"
            style={{ width: 50, height: 50, objectFit: "contain" }}
          />
        ) : (
          "No Icon"
        ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            size="small"
            color="error"
            sx={{ ml: 1 }}
            onClick={() => handleTrash(params.row.id)}
          >
            Trash
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box p={3}>
      <ToastContainer />
      <Typography variant="h5" gutterBottom>
        International Insurance Partners
      </Typography>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => setOpenDialog(true)}
      >
        Add Insurance Partner
      </Button>

      <Box mt={2}>
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row.id}
          autoHeight
        />
      </Box>

      <Dialog open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {isEditMode ? "Edit" : "Add"} Insurance Partner
        </DialogTitle>
        <DialogContent>
          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload Icon
            <input
              type="file"
              name="icon"
              hidden
              onChange={handleInputChange}
            />
          </Button>

          {(formData.icon || formData.existing_icon) && (
            <Box mt={2}>
              <Typography variant="subtitle2">Preview:</Typography>
              <img
                src={
                  formData.icon
                    ? URL.createObjectURL(formData.icon)
                    : `${baseImage_path}/${formData.existing_icon}`
                }
                alt="Preview"
                style={{ width: 100, height: 100, objectFit: "cover" }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            style={{ fontWeight: "bold", backgroundColor: "grey" }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            {isEditMode ? "Save" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default InternationalInsuranceCMS;
